module.exports = __webpack_public_path__ + "static/media/creative-commons-share.2225a1b5.svg";